import LacunaWebPKI from 'web-pki';

const webPKI = new LacunaWebPKI(process.env.WEBPKI_TOKEN);

export default webPKI;
